<template>
	<div class="mobile-control">
		<h2 class="mobile-control__anons" v-text="anons"/>
	</div>
</template>

<script>
export default {
	data() {
		return {
			anons:   'Задать вопрос',
			buttons: [
				// {
				// 	title: 'Смотреть эфир'
				// },
				{
					title: '8-800-200-40-40',
					value: 88002004040,
					type:  'phone'
				},
				// {
				// 	title: 'Написать'
				// }
			]
		}
	}
}
</script>

<style lang="scss">
@import "../assets/scss/config";

.mobile-control {
	display: none;

	@media screen and ($media-mobile) {
		display: block;
		position: relative;
		z-index: 2;
	}

	&__anons {
		font: 24px/95% 'GolosText', sans-serif;
		margin: 24px 16px 24px;
	}

	&__list {
		margin: 0 16px 256px;
		padding: 0;
		list-style: none;
	}

	&__item {
		margin: 0 0 4px;

		&:last-child {
			margin: 0;
		}
	}

	&__button {
		-webkit-appearance: none;
		text-decoration: none;
		background: $color-red;
		font: 16px/48px 'RF Devi Semi Bold', sans-serif;
		color: $color-white;
		text-align: center;
		display: block;
		border-radius: 8px;
	}
}
</style>